const projects = [
    {val: 0, label: ''},
    {val: 1, label: 'POCU Cod SMIS 106557'}
]
const entityFields = {
	page: [
		{
			name: 'header',
			type: 'img',
			label: 'Antet',
			single: true,
			prepare: (config) => {
				if (config.entity.header && config.entity.header.length>0) config.bg = config.entity.header
				return config
			}
		},
		{
			name: 'title',
			type: 'text',
			label: 'Titlu',
			transition: true
		},
		{
			name: 'body',
			type: 'html',
			label: 'Conținut',
		}
	],
	
	article: [
		{
			name: 'header',
			type: 'img',
			style: 'header',
			label: 'Imagine Antet',
			single: true
		},
		{
			name: 'title',
			type: 'text',
			label: 'Titlu',
			t: true
		},
		{
			name: 'date',
			type: 'date',
			label: 'Data',
		},
		{
			name: 'body',
			type: 'html',
			label: 'Conținut',
			t: true
		},
		{
			name: 'gallery',
			type: 'img',
			label: 'Galerie',
		},
		{
			name: 'summary',
			type: 'html',
			label: 'Sumar',
			t: true
		},
		{
			name: 'thumb',
			type: 'img',
			label: 'Miniatură',
			single: true
		},
		{
			name: 'docs',
			type: 'doc',
			label: 'Documente'
		},
	    {
		name: 'project',
		type: 'select',
                values: projects,
		label: 'Proiect'
	    }
		
	],
	
	document: [
		{
			name: 'title',
			type: 'text',
			label: 'Titlu',
		},
		{
			name: 'date',
			type: 'date',
			label: 'Data',
		},
		{
			name: 'doc',
			type: 'doc',
			label: 'Document',
		},
		{
			name: 'thumb',
			type: 'img',
			label: 'Miniatură',
			single: true,
			default: '/upload/default/imagine.jpg'
		}
	],
	
	anunt: [
		{
			name: 'title',
			type: 'text',
			label: 'Titlu',
		},
		{
			name: 'date',
			type: 'date',
			label: 'Data',
		},
		{
			name: 'doc',
			type: 'doc',
			label: 'Document',
		},
		{
			name: 'thumb',
			type: 'img',
			label: 'Miniatură',
			single: true,
			default: '/upload/default/anunt.png'
		}
	],
	
	revista: [
		{
			name: 'title',
			type: 'text',
			label: 'Titlu',
		},
		{
			name: 'date',
			type: 'date',
			label: 'Data',
		},
		{
			name: 'doc',
			type: 'doc',
			label: 'Document',
		},
		{
			name: 'thumb',
			type: 'img',
			label: 'Miniatură',
			single: true
		}
	],
	
	video: [
		{
			name: 'title',
			type: 'text',
			label: 'Titlu',
		},
		{
			name: 'date',
			type: 'date',
			label: 'Data',
		},
		{
			name: 'video',
			type: 'video',
			label: 'Video',
		},
		{
			name: 'body',
			type: 'html',
			label: 'Conținut',
			t: true
		},
		{
			name: 'thumb',
			type: 'img',
			label: 'Miniatură',
			computed: true
		},
		{
			name: 'section',
			type: 'link',
			label: 'Secțiune',
			computed: true
		},
		
	],
	
	person: [
		{
			name: 'first_name',
			type: 'text',
			label: 'Prenume',
		},
		{
			name: 'last_name',
			type: 'text',
			label: 'Nume',
		},
		{
			name: 'img',
			type: 'img',
			label: 'Imagine'
		},
		{
			name: 'position',
			type: 'text',
			label: 'Funcția',
		},
		{
			name: 'body',
			type: 'html',
			label: 'Prezentare',
		},
		{
			name: 'ord',
			type: 'int',
			label: 'Ordine',
		},
	],
	
	folder: [
		{
			name: 'folder',
			type: 'select',
			dataSource: 'folderList',
			label: 'Dosar părinte'
		},
		{
			name: 'name',
			type: 'text',
			label: 'Nume',
		},
	],
	
	resource: [
		{
			name: 'title',
			type: 'text',
			label: 'Titlu',
		},
		{
			name: 'folder',
			type: 'select',
			dataSource: 'folderList',
			label: 'Dosar'
		},
		{
			name: 'date',
			type: 'date',
			label: 'Data',
		},
		{
			name: 'doc',
			type: 'doc',
			label: 'Document',
		},
	],
	
	link: [
		{
			name: 'link',
			type: 'link',
			label: 'Legătură',
		},
	]
}
const entityLayout = {
	article: {
		hero: ['title'],
		center: ['body', 'gallery']
	}
}
const entityFrag = {
	article: true
}

export {entityFields, entityLayout, entityFrag}



// WEBPACK FOOTER //
// ./src/conf/entity.js